<template>
  <div class="chats">
    <div class="chat chat-left">
      <!-- <div class="chat-information">
        <div class="badge-chat">
          {{ $t("action.start") }}
        </div>
        <div class="text-center">
          <small>
            {{ activeChannel.createdAt | formatDate }}
          </small>
        </div>
      </div> -->
      <div>
        <div class="text-center p-1 pb-0">
          <strong>{{ activeChannel.createdAt | formatDate }}</strong>
        </div>
        <div class="text-center">
          <b-badge
            pill
            :variant="activeChannel.status == 'started' ? 'info' : 'primary'"
          >
            {{ $t(`status.${activeChannel.status}`) }}</b-badge
          >
        </div>
        <div class="text-center">
          {{ secondsToDHMS(activeChannel.callDurationInSeconds) }}
        </div>
      </div>

      <div class="text-center">
        <div class="text-center mt-2 mb-1">
          <strong
            v-if="
              activeChannel.recordingUrls &&
              activeChannel.recordingUrls.length > 0
            "
            >{{ $t("call.recordedVoice") }}</strong
          >
          <strong v-else>{{ $t("call.noVoiceRecord") }}</strong>
        </div>

        <audio
          v-for="voice in activeChannel.recordingUrls"
          :key="voice"
          controls="controls"
          autobuffer="autobuffer"
          class="voice"
        >
          <source :src="voice" />
        </audio>
      </div>
    </div>
  </div>
</template>

<script>
import { BBadge } from "bootstrap-vue";
import messageStatus from "@/data/messageStatus";
import messageType from "@/data/messageType";
import conversationStatus from "@/data/conversationStatus";
import languageEn from "@/data/languages/en";
import { getCountryByLanguageCode, secondsToDHMS } from "@/libs/helper";
import localeCountries from "@/data/localeCountries";
import useJwt from "@/auth/jwt/useJwt";
import Repository from "@/repositories/RepositoryFactory";
import {
  isVideo,
  isDoc,
  isImage,
  isCsv,
  isExcel,
  isPdf,
  isWord,
} from "../../helpers/fileHelper";

const TranslateRepository = Repository.get("translateRepository");
const ChatMessageRepository = Repository.get("chatMessage");

export default {
  components: {
    BBadge,
  },
  props: {
    activeChannel: {
      type: Object,
      default: () => ({}),
    },
    messages: {
      type: Array,
      default: () => [],
    },
    readMessage: {
      type: String,
      default: "",
    },
    isTyping: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      image: "",

      messageStatus,
      messageType,
      conversationStatus,
      loading: false,
    };
  },
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
  },
  methods: {
    confirmDelete(messageId) {
      this.$bvModal
        .msgBoxConfirm(this.$t("alert.deleteThisMessage"), {
          title: this.$t("alert.areYouSure"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          okTitle: this.$t("button.delete"),
          cancelTitle: this.$t("button.cancel"),
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.deleteMessage(messageId);
          }
        });
    },
    deleteMessage(messageId) {
      ChatMessageRepository.delete(messageId)
        .then((response) => {})
        .then((error) => {
          this.isModalOpen = false;
        });
    },
    systemTranslatedMessage(message) {
      return message?.chatSettings?.translatedMessage;
    },
    systemDetectedLanguage(message) {
      return message?.chatSettings?.detectedLanguage;
    },
    systemTranslatedLanguage(message) {
      return message?.chatSettings?.translatedLanguage;
    },
    actionTransfer() {
      if (this.activeChannel?.transferredFrom) {
        return this.$t("action.transferringFrom");
      }
      return this.$t("action.transferringTo");
    },

    mapTransferMerchantName(createdAt) {
      if (this.activeChannel?.transferredFrom) {
        return this.activeChannel.transferredFromName || "N/A";
      }
      if (this.activeChannel?.transferred) {
        const transferring = this.activeChannel.transferred.find(
          (e) =>
            e.startedAt <= createdAt && (!e.endedAt || createdAt <= e.endedAt)
        );
        if (transferring) {
          return transferring?.toName || "NO NAME";
        }
      }
      return "N/A";
    },
    getCountryCode(language) {
      return this.localeCountries.find(
        (e) => e.language.toLowerCase() === language?.toLowerCase()
      )?.flag;
    },
    isTranslate() {
      return (
        this.activeChannel.isAutoTranslate ||
        JSON.parse(localStorage.getItem("chatSettings")).isTranslationOn == 1
      );
    },
    getEmoji(target) {
      if (target == null) {
        return;
      }
      const data = this.getCountryByLanguageCode(this.languageEn, target);
      return data?.emoji;
    },
    createObjectURL(file) {
      return window.URL.createObjectURL(file);
    },
    openFile(url) {
      if (!url) return;
      window.open(url, "_blank");
    },
    getFileName(message) {
      return message.mediaUrl || message.file?.name;
    },
    viewImage(message) {
      const image = message?.mediaUrl;
      if (image) {
        this.image = image;
      }
    },
    retrySendMessage(index) {
      if (this.activeChannel.state == this.conversationStatus.open) {
        this.$emit("retry", index);
      }
    },
    onTranslate(index) {
      // this.$emit("translate", index);
      this.loading = true;
      const message = this.messages[index];
      const target = this.$i18n.locale;
      TranslateRepository.translate({ text: message.message, target })
        .then((response) => {
          this.messages[index].translatedMessage =
            response?.data?.data?.translatedMessage;
          this.messages[index].translatedLanguage =
            response?.data?.data?.translatedLanguage;
          this.messages[index].detectedLanguage =
            response?.data?.data?.detectedLanguage;
          this.chatBoxKey += 1;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  setup() {
    return {
      getCountryByLanguageCode,
      languageEn,
      localeCountries,
      isImage,
      isVideo,
      isDoc,
      isCsv,
      isExcel,
      isPdf,
      isWord,
      secondsToDHMS,
    };
  },
};
</script>

<style scoped lang="scss">
audio::-webkit-media-controls-play-button,
audio::-webkit-media-controls-panel {
  background-color: rgb(232, 232, 232);
}

audio {
  height: 30px;
}

.detail-container {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  div {
    display: flex;
    gap: 0.5rem;
  }
}
</style>
